<template>
  <header class="header show-langs">
    <div class=wrapper>
        <a href="https://karmabot.chat/" class="header__logo not-decorated">
          <img src="~@/assets/images/karmabot-logo--light.svg" width=185 alt="Karma bot" /></a>
        <div class="header__menu menu-header menu-header--casual is-full">
            <ul class=menu-header__list>
                <li class="menu-header__item menu-header__item--slack"><a class="not-decorated" href="https://karmabot.chat/">Slack</a></li>
                <li class="menu-header__item menu-header__item--ms"><a class="not-decorated" href="https://karmabot.chat/ms">MS Teams</a></li>
                <li class="menu-header__item menu-header__item--telegram"><a class="not-decorated" href="https://karmabot.chat/telegram">Telegram</a></li>
            </ul>
        </div>
        <div class=header__actions>
            <div class=header__login><a class="btn btn--outline" href="https://app.karmabot.chat/login">Login</a></div>
        </div>
    </div>
</header>
</template>

<script>
  export default {
    
  }
</script>

<style lang="sass" scoped>
  @import '../assets/styles/utils.sass'

  .header
    width: 100%
    padding: 30px 0
    // position: absolute
    top: 0
    left: 0
    z-index: 10

    @media screen and (max-width: 600px)
      padding: 20px 0

    .wrapper
      display: flex
      max-width: 1470px
      justify-content: space-between
      align-items: center
      padding: 0 30px

      @media screen and (max-width: 600px)
        padding: 0 20px


    &__logo
      display: block
      flex: 1
      width: 0

      img

        @media screen and (max-width: 600px)
          width: 140px

        +media(mobile-nano)
          width: 120px

        +ie11()
          width: 40% !important

    &__menu

      .show-langs &

        +media(tablet-landscape)
          margin-left: -25px

      @media screen and (max-width: 770px)
        position: absolute
        width: 100%
        margin-left: -20px
        top: 55px
        padding: 15px 0
        background: rgba(#000, 0.05)

    &__actions
      flex: 1
      width: 0
      display: flex
      justify-content: flex-end

    &__langs
      margin-right: 25px

      @media screen and (max-width: 600px)
        margin-right: 10px

    &__login

      .btn
        @media screen and (max-width: 600px)
          padding: 0

        .show-langs &
          +media(mobile-nano)
            min-width: 70px


  // Menu
  .menu-header
    $p: &

    &__list
      display: flex
      justify-content: center

      .is-full &

        +media(tablet-portrait)
          margin-right: -100px
        
        +media(mobile)
          margin-right: 0
          padding: 0 15px
          justify-content: space-between

    &__item
      font-size: 13px
      font-weight: bold
      letter-spacing: 0.7px
      text-transform: uppercase
      margin: 0 25px

      +media(tablet-landscape)
        margin: 0 15px

      +media(tablet-portrait)
        margin: 0 5px

      +media(mobile)
        margin: 0 5px
        font-size: 11px
        letter-spacing: 0.4px

      +media(mobile-nano)
        margin: 0 3px
        font-size: 9px
        letter-spacing: 0.1px


      &--slack a

        &::before
          width: 22px
          height: 22px
          +image('icon-slack-new.svg')

          +media(mobile)
            width: 19px
            height: 19px

      &--ms a

        &::before
          width: 23px
          height: 22px
          +image('icon-ms-teams.svg')

          +media(mobile)
            width: 19px
            height: 19px

      &--telegram a

        &::before
          width: 22px
          height: 22px
          +image('icon-telegram.svg')

          +media(mobile)
            width: 19px
            height: 19px

    a
      color: #fff
      display: flex
      padding: 10px 20px
      border-radius: 100px
      align-items: center

      +media(tablet-portrait)
        padding: 10px 15px

      +media(mobile)
        padding: 0 12px
        height: 40px
        justify-content: center
        align-items: center
        border-radius: 4px
        white-space: nowrap

      +media(mobile-nano)
        height: 35px

      &::before
        content: ''
        background-repeat: no-repeat
        background-position: center
        background-size: cover
        margin-right: 10px

        +media(mobile)
          margin-right: 7px

      &:hover
        background: rgba(#fff, 0.03)
        color: rgba(#fff, 0.9)

      &.is-active
        background: rgba(#fff, 0.97)
        color: #1C2E39
        cursor: default
        box-shadow: 0 5px 30px rgba(#000, 0.1)
        background: linear-gradient(to bottom, #fff, rgba(255, 255, 255, 0.925))

        +media(mobile)
          font-size: 11px

        +media(mobile-nano)
          font-size: 9px

        &:hover
          opacity: 1



  // Langs
  .langs
    position: relative

    .flag
      width: 16px
      height: 16px
      background-repeat: no-repeat
      background-position: center
      background-size: cover
      display: block
      margin-right: 8px
      border-radius: 100px
      overflow: hidden

      &--en
        +image('flag-en.svg')

      &--ru
        +image('flag-ru.svg')

    &__active
      height: 40px
      background: rgba(#fff, 0.005)
      transition: all ease 0.3s
      border-radius: 4px
      padding: 0 15px
      display: flex
      align-items: center
      color: #fff
      text-transform: uppercase
      font-size: 12px
      font-weight: bold
      letter-spacing: 0.8px
      cursor: pointer

      @media screen and (max-width: 600px)
        padding: 0 10px
        font-size: 10px

      +media(mobile-nano)
        padding: 0 5px

      &::after
        position: relative
        top: 1px
        content: ''
        display: block
        margin-left: 10px
        width: 0
        height: 0
        border-style: solid
        border-width: 4px 4px 0 4px
        border-color: #fff transparent transparent transparent
        transition: all ease 0.3s

        @media screen and (max-width: 600px)
          display: none

        .is-langs-show &
          transform: rotate(180deg)

      &:hover
        background: rgba(#fff, 0.025)

      .is-langs-show &
        background: rgba(#fff, 0.035)


    &__list
      opacity: 0
      visibility: hidden
      position: absolute
      transition: all ease 0.3s
      transform: scale(0.9) translateY(0)
      width: 110%
      left: -5%
      border-radius: 4px
      box-shadow: 0 5px 20px rgba(#000, 0.15)
      background: #fff

      @media screen and (max-width: 600px)
        width: 100px
        left: -13px

      &::before
        content: ''
        position: absolute
        width: 0
        height: 0
        border-style: solid
        border-width: 0 4px 4px 4px
        border-color: transparent transparent #fff transparent
        transition: all ease 0.3s
        top: -4px
        left: 50%
        margin-left: -4px

      .is-langs-show &
        opacity: 1
        visibility: visible
        transform: translateY(10px) scale(1)

      .is-langs-show &::before
        margin-left: -4px


    &__item

      &:first-child
        overflow: hidden
        border-radius: 4px 4px 0 0

      &:last-child
        overflow: hidden
        border-radius: 0 0 4px 4px

    &__link
      color: #1C2E39
      padding: 0 25px
      height: 40px
      display: flex
      font-size: 12px
      font-weight: bold
      letter-spacing: 0.8px
      text-transform: uppercase
      align-items: center
      background: #fff

      &:hover
        background: #e8ecee

      &::before
        content: ''
        @extend .flag

      &--ru::before
        +image('flag-ru.svg')

      &--en::before
        +image('flag-en.svg')

      .is-active &
        opacity: 0.8
        cursor: default
        color: #8496a0

        &:hover
          background: transparent
</style>
